import { graphql } from '../../../graphql/generated';

export const DELETE_LAB_TRANSFER_DOCUMENT_MUTATION = graphql(`
  mutation DeleteLabTransferDocument($id: ID!) {
    deleteLabTransferDocument(id: $id) {
      id
    }
  }
`);

export const DELETE_LAB_AIS_EXPORT_DOCUMENT_MUTATION = graphql(`
  mutation DeleteLabAisExportDocument($id: ID!) {
    deleteLabAisExportDocument(id: $id) {
      id
    }
  }
`);

export const DELETE_LAB_ELGA_OPT_OUT_DOCUMENT_MUTATION = graphql(`
  mutation DeleteLabElgaOptOutDocument($id: ID!) {
    deleteLabElgaOptOutDocument(id: $id) {
      id
    }
  }
`);

export const LAB_QUERY = graphql(`
  query DocumentsLab($id: ID!) {
    lab(id: $id) {
      id
      hasTransferDocument
      hasAisExportDocument
      hasElgaOptOutDocument
    }
  }
`);
